module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-heads"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/f007",
      "id": "s1"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/f008",
      "id": "s2"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop"
  }, [_c('a', {
    attrs: {
      "href": "#/f009",
      "id": "c1"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Case Study 1: John Wayne Michael Gacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/f010",
      "id": "s3"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Living up to Expectations")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "href": "#/f011",
      "id": "s4"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Hunting… and Hunted")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f012",
      "id": "s5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Bodies of Evidence")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f013",
      "id": "s6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Into the Net")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f014",
      "id": "s7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Judge and Executioner")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop"
  }, [_c('span', {
    attrs: {
      "href": "#/f015",
      "id": "c2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Case Study 2: Kenneth Alessio Bianchi")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f016",
      "id": "s8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Liar, Liar…")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f017",
      "id": "s9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Police Make a Killing")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f018",
      "id": "s10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("The Truth Will Out")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f019",
      "id": "s11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Acting Up")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f020",
      "id": "s12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Femme Fatale")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop"
  }, [_c('span', {
    attrs: {
      "href": "#/f021",
      "id": "c3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Case Study 3: William George Heirens")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f022",
      "id": "s13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Daylight Robberies")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f023",
      "id": "s14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Without a Clue")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop"
  }, [_c('span', {
    attrs: {
      "href": "#/f024",
      "id": "c4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Case Study 4: John David Guise Cannan")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f025",
      "id": "s15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Prince Charming")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f026",
      "id": "s16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("True Lies")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f027",
      "id": "s17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Desperately Seeking Suzy")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f028",
      "id": "s18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Sex Drive")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal mtop"
  }, [_c('span', {
    attrs: {
      "href": "#/f029",
      "id": "c5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Case Study 5: Patricia Wright")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f030",
      "id": "s19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Insufficient Evidence")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    attrs: {
      "href": "#/f031",
      "id": "s20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Paying a Premium")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b340196","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f006.vue
// module id = 72
// module chunks = 0